import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

export type LayoutShellProps = {
  header?: ReactNode;
  sidebar?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function LayoutShell({ header, sidebar, children, className }: LayoutShellProps) {
  return (
    <div className={cn("bfrs-min-h-dvh bfrs-bg-surface-app bfrs-text-text-primary", className)}>
      {header && <header className="bfrs-sticky bfrs-top-0 bfrs-z-30 bfrs-border-b bfrs-border-border bfrs-bg-surface-card/90 bfrs-backdrop-blur">{header}</header>}
      <div className="bfrs-mx-auto bfrs-grid bfrs-w-full bfrs-max-w-7xl bfrs-gap-6 bfrs-px-5 bfrs-py-6 sm:bfrs-px-8 lg:bfrs-grid-cols-[260px_minmax(0,1fr)]">
        {sidebar && <aside className="bfrs-hidden lg:bfrs-block">{sidebar}</aside>}
        <main className="bfrs-min-w-0">{children}</main>
      </div>
    </div>
  );
}
